import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import ComponentPageHeader from '../../../Common/PageHeader/ComponentPageHeader';
import ComponentReportListTable from './Components';
import { exportToExcelData } from '../../../Common/PageHeader/helper';
import { RootState } from '../../../redux/rootState';

function ScreenReportList() {
  const { ReportListData } = useSelector((state: RootState) => state.ListReportReducer);

  const excelData = useMemo(() => ReportListData?.Data?.map((item) => {
    const transformedDataItems = {
      Description: item?.Description,
    };
    return transformedDataItems;
  }), [ReportListData]);

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Report_type_list',
    );
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="REPORT TYPE LIST" downloadExcel={downloadExcel} />
      </Grid>
      <div className="whiteSpace" />
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <ComponentReportListTable />
      </Grid>
    </Grid>
  );
}

export default ScreenReportList;
